import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M11.6681 2.0012C11.6681 0.764435 10.0641 0.278789 9.37807 1.30783L2.65662 11.39C2.10282 12.2207 2.69831 13.3334 3.69668 13.3334H8.3348V17.9989C8.3348 19.2356 9.93883 19.7213 10.6249 18.6923L17.3463 8.61009C17.9001 7.7794 17.3046 6.66671 16.3063 6.66671H11.6681V2.0012Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }